var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 11C22.5 17.0751 17.5751 22 11.5 22C5.42487 22 0.5 17.0751 0.5 11C0.5 4.92487 5.42487 0 11.5 0C17.5751 0 22.5 4.92487 22.5 11ZM11.8942 8.12068C10.8243 8.5657 8.68596 9.48676 5.47924 10.8839C4.95851 11.091 4.68574 11.2935 4.6609 11.4916C4.61894 11.8264 5.03815 11.9582 5.60901 12.1377C5.68667 12.1621 5.76712 12.1874 5.84961 12.2142C6.41125 12.3968 7.16676 12.6104 7.55951 12.6189C7.91578 12.6266 8.31342 12.4797 8.75242 12.1782C11.7486 10.1558 13.2952 9.13349 13.3923 9.11145C13.4608 9.09591 13.5557 9.07636 13.62 9.13352C13.6844 9.19069 13.678 9.29896 13.6712 9.328C13.6297 9.50504 11.9841 11.0349 11.1325 11.8266C10.867 12.0734 10.6787 12.2485 10.6402 12.2885C10.554 12.3781 10.4661 12.4628 10.3816 12.5442C9.85987 13.0472 9.46859 13.4244 10.4033 14.0404C10.8525 14.3364 11.212 14.5812 11.5705 14.8254C11.9622 15.0921 12.3528 15.3581 12.8581 15.6894C12.9869 15.7738 13.1099 15.8614 13.2296 15.9468C13.6854 16.2717 14.0949 16.5636 14.6007 16.5171C14.8946 16.49 15.1983 16.2136 15.3525 15.3893C15.7169 13.4412 16.4332 9.22025 16.5987 7.48089C16.6132 7.3285 16.595 7.13347 16.5803 7.04786C16.5657 6.96225 16.535 6.84027 16.4238 6.74997C16.292 6.64303 16.0885 6.62047 15.9975 6.62208C15.5838 6.62937 14.949 6.85008 11.8942 8.12068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.bcfbac1f4b97ecb355476df882d12ccf.svg";
export { ForwardRef as ReactComponent };